import React from 'react'

const MyBookings = () => {
  return (
    <div ID="book-travel" className="content">
      Here goes my bookings.
    </div>
  )
}

export default MyBookings
